// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"139":"91b7aa66edda88dc","646":"0e636499d87f8634","851":"353877c8b83d70e6","881":"db5470db76f26ed4"}[chunkId] + ".js";
};